export const MOBILE_BREAKPOINT = '(max-width: 800px)';
export const TABLET_BREAKPOINT = '(max-width: 1280px)';
